"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormError = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const lib_1 = require("./lib");
const Animation_1 = require("../Animation");
const StyledFormError = app_1.styled.div `
  color: ${(theme) => theme.colors.error};
`;
function FormError({ className }) {
    var _a;
    const { formError, registerFormError, unregisterFormError } = (_a = (0, react_1.useContext)(lib_1.InternalFormContext)) !== null && _a !== void 0 ? _a : {};
    const [fatal, setFatal] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (fatal) {
            console.error(`FATAL: ${fatal}`);
        }
    }, [fatal]);
    (0, react_1.useEffect)(() => {
        if (registerFormError && unregisterFormError) {
            registerFormError();
            return unregisterFormError;
        }
        setFatal('FormError has to be contained by a <Form> component');
    }, [registerFormError, unregisterFormError]);
    return fatal ? ((0, jsx_runtime_1.jsxs)("div", { children: ["FATAL: ", fatal] })) : ((0, jsx_runtime_1.jsx)(Animation_1.Animation, Object.assign({ auto: "height" }, { children: typeof formError === 'string' && ((0, jsx_runtime_1.jsx)(StyledFormError, Object.assign({ className: className }, { children: formError }))) })));
}
exports.FormError = FormError;
